/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function ContactFilledIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="contact-filled"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M1.75 6.5C1.783 5.794 2.099 5.012 2.555 4.555C3.012 4.099 3.794 3.783 4.5 3.75L19.5 3.75C20.206 3.783 20.988 4.099 21.445 4.555C21.901 5.012 22.217 5.794 22.25 6.5L22.25 17.5C22.217 18.206 21.901 18.988 21.445 19.445C20.988 19.901 20.206 20.217 19.5 20.25L4.5 20.25C3.794 20.217 3.012 19.901 2.555 19.445C2.099 18.988 1.783 18.206 1.75 17.5L1.75 6.5ZM10.433 7.636C9.98 7.182 9.201 6.835 8.5 6.835C7.799 6.835 7.02 7.182 6.567 7.636C6.113 8.089 5.766 8.868 5.766 9.569C5.766 10.27 6.113 11.048 6.567 11.502C7.02 11.955 7.799 12.302 8.5 12.302C9.201 12.302 9.98 11.955 10.433 11.502C10.887 11.048 11.234 10.27 11.234 9.569C11.234 8.868 10.887 8.089 10.433 7.636ZM5.653 16.39C6.229 15.268 7.24 14.729 8.5 14.729C9.123 14.729 9.625 14.87 10.148 15.174C10.408 15.326 10.61 15.482 10.823 15.697C11.037 15.913 11.467 16.548 11.467 16.548C11.436 16.511 11.467 16.548 11.467 16.548C11.759 16.842 12.234 16.844 12.528 16.553C12.822 16.261 12.824 15.786 12.533 15.492C12.533 15.492 12.564 15.529 12.533 15.492C12.533 15.492 12.171 14.926 11.888 14.641C11.605 14.355 11.248 14.079 10.903 13.879C10.217 13.478 9.326 13.229 8.5 13.229C6.862 13.229 5.199 14.25 4.347 15.65C4.143 16.011 4.27 16.469 4.63 16.673C4.991 16.877 5.449 16.75 5.653 16.39ZM14 9.75L19 9.75C19.414 9.75 19.75 9.414 19.75 9C19.75 8.586 19.414 8.25 19 8.25L14 8.25C13.586 8.25 13.25 8.586 13.25 9C13.25 9.414 13.586 9.75 14 9.75ZM15 15.75L18.5 15.75C18.914 15.75 19.25 15.414 19.25 15C19.25 14.586 18.914 14.25 18.5 14.25L15 14.25C14.586 14.25 14.25 14.586 14.25 15C14.25 15.414 14.586 15.75 15 15.75Z" data-tinysvg-shape="compound-path" fillRule="evenodd" stroke="none" fill={color} data-fill-tone="primary" />
    </svg>
  )
}
